import React from 'react';
import { createPortal } from 'react-dom';
import * as styles from './PreviewEmbed.module.scss';
import ExternalBrandLogo from '../../../../components/ExternalBrandLogo';
import getExternalBrandLogoProps from '../../../../integrations/getExternalBrandLogoProps';
import type { EmbedValue } from '../../../embed/matchEmbed';
import { EmbedMode, embedUrl } from '../../../embed/matchEmbed';
import MentionBase from '../../../mentions/MentionBase';
import Embed from '../../Embed';

class PreviewEmbed extends Embed {
  static shouldLazyLoad = false;

  static create(value: EmbedValue) {
    const node = super.create(value);
    node.classList.add(styles.container, 'ql-preview-embed');
    return node;
  }

  renderPortal() {
    const { domNode } = this;
    const { content } = this.statics.formats(domNode) || {};

    const { id, type } = this.statics.value(domNode);

    const fullUrl = embedUrl({ id, type }, EmbedMode.FULL);

    return createPortal(
      <MentionBase
        type={type}
        icon={<ExternalBrandLogo inline {...getExternalBrandLogoProps(type)} />}
        content={content || fullUrl}
        to={fullUrl || undefined}
        newTab
      />,
      domNode,
    );
  }
}

export default PreviewEmbed;
